import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonProductQuotation = ({ rows = 4 }) => (
  <table className="table quote-table product-size-grid" aria-label="Loading quotation products">
    <thead>
      <tr>
        <th><Skeleton width={16} height={16} /></th>
        <th>#</th>
        <th>Tag Ref</th>
        <th>Width</th>
        <th>Height</th>
        <th>Quantity</th>
        <th>Unit Price</th>
        <th>Margin(+) / Discount(-)</th>
        <th>Total Price</th>
        <th>Notes</th>
      </tr>
    </thead>
    <tbody>
      {Array.from({ length: rows }, (_, index) => (
        <tr key={index}>
          <td><Skeleton width={16} height={16} /></td>
          <td><Skeleton width={14} /></td>
          <td><Skeleton height={15} /></td>
          <td><Skeleton height={15} /></td>
          <td><Skeleton height={15} /></td>
          <td><Skeleton height={15} /></td>
          <td><Skeleton width={58} /></td>
          <td><Skeleton height={15} /></td>
          <td><Skeleton width={64} /></td>
          <td><Skeleton width={110} /></td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default SkeletonProductQuotation;
